import styled from "styled-components";

import Image from "../../../assets/images/sections/footer/background.jpg";

export const Container = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-image: url(${Image});
  background-repeat: no-repeat;
  background-size: cover;

  footer {
    background-color: #28a137;
    padding: 20px;
    width: 100%;
    text-align: center;
    color: white;
    font-family: "GothamPro";
    font-weight: 100;
  }
`;

export const Content = styled.div`
  max-width: 1240px;
  width: 100%;
  padding: 50px 20px;
  display: flex;
  justify-content: space-between;
  gap: 20px;

  nav {
    max-width: 350px;
  }

  a {
    text-decoration: none;
    color: #f8f6f5;
    display: flex;
    gap: 12px;
    align-items: center;
  }

  div > img {
    width: 127px;
    height: 169px;
    margin-bottom: 58px;
  }

  ul {
    list-style: none;
    color: #f8f6f5;
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  li {
    display: flex;
    gap: 12px;
    align-items: center;
    font-weight: 100;
  }

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const Form = styled.form`
  max-width: 591px;
  width: 100%;
  background-color: white;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  position: relative;
  padding: 20px;

  label {
    font-weight: bold;
    color: #333333;
    font-size: 15px;
  }

  input {
    height: 35px;
    padding-left: 10px;
  }

  input,
  textarea {
    border: 1px solid #dadada;
  }

  textarea {
    height: 92px;
    padding: 10px;
  }

  button {
    background-color: #28a137;
    border: none;
    color: white;
    font-size: 18px;
    font-weight: bold;
    padding: 8px 0;
    border-radius: 5px;
    cursor: pointer;
  }

  div div {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 5px;

    span {
      font-weight: 100;
    }

    @media (max-width: 425px) {
      align-items: start;
      flex-direction: column;

      div {
        flex-direction: row;
        align-items: center;
      }
    }
  }
`;

export const Loading = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: white;
  border-radius: 10px;
  top: 0px;
  right: 0px;

  > div {
    border: 8px solid #f3f3f3;
    border-top: 8px solid #28a137;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
